const getYoutubeVideoId = url => url.match(/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#&?]*).*/)[2];

const getVimeoVideoId = url => url.split('/').pop();

const getYoutubeThumbnailImageUrl = url => `https://img.youtube.com/vi/${getYoutubeVideoId(url)}/0.jpg`;

const getVimeoEmbedUrl = url => `https://player.vimeo.com/video/${getVimeoVideoId(url)}`;

const getYoutubeEmbedUrl = url => `https://youtube.com/embed/${getYoutubeVideoId(url)}`;

const getVideoProvider = url => (url.indexOf('youtube') > -1 ? 'youtube' : 'vimeo');

const getVideoUrl = (url) => {
    let parsedUrl = null;

    if (url) {
        parsedUrl = getVideoProvider(url) === 'youtube'
            ? getYoutubeEmbedUrl(url)
            : getVimeoEmbedUrl(url);
    }

    return parsedUrl;
};

module.exports = {
    getYoutubeThumbnailImageUrl,
    getVideoUrl,
};
